export type OdooMany2One = [number, string] | false;

export default class PurchaseOrder {
  id: number;
  name: string;
  amount_total: number;
  currency_id: OdooMany2One;
  companyId: number;

  static fromJSON(o: Object): PurchaseOrder {
    const purchaseOrder = new PurchaseOrder();
    purchaseOrder.id = o["id"];
    purchaseOrder.name = o["name"];
    purchaseOrder.amount_total = o["amount_total"];
    purchaseOrder.currency_id = o["currency_id"];
    const company = o["company_id"];
    purchaseOrder.companyId = Array.isArray(company) ? company[0] : company;
    return purchaseOrder;
  }
}
